var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4997 3.14356C10.0334 3.14356 3.14355 10.0326 3.14355 18.5001C3.14355 26.9674 10.0334 33.8564 18.4997 33.8564C26.9661 33.8564 33.8559 26.9674 33.8559 18.5001C33.8559 10.0326 26.9661 3.14356 18.4997 3.14356ZM25.681 14.7754L16.957 23.5015C16.7807 23.6778 16.5501 23.7668 16.3161 23.7668C16.0856 23.7668 15.855 23.6778 15.6787 23.5015L11.315 19.1389C10.9624 18.7862 10.9624 18.2139 11.315 17.8612C11.6676 17.5086 12.2406 17.5086 12.5932 17.8612L16.3161 21.5858L24.4062 13.4985C24.7588 13.1458 25.3318 13.1458 25.6811 13.4985C26.0371 13.8512 26.0371 14.4228 25.681 14.7754Z",
    fill: "#70E6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi);
export default __webpack_public_path__ + "static/media/fi.fed79badf31b710a756d6159945fa52b.svg";
export { ForwardRef as ReactComponent };